import React, { memo, useState } from 'react';
import {
  Avatar,
  Button,
  Dialog,
  Line,
  MyBottomSheet,
  Spacing,
  Typography,
} from 'components/src';
import { FlatList, View } from 'react-native';
import {
  createUseStyles,
  useLang,
  usePutChatUpdateGroup,
  userInfo,
} from 'core/src';
import { useTranslation } from 'react-i18next';
import { StackNavigationProp } from '@react-navigation/stack';
import {
  Store,
  showBottomSheetUpdate,
} from '../../organisms/myBottomsheet/store';
import { useToast } from 'react-native-toast-notifications';
import AntDesign from 'react-native-vector-icons/AntDesign';

const AntDesignX = AntDesign as unknown as React.ComponentType<any>;

interface Props {
  data: any;
  navigation: StackNavigationProp<any>;
  admin: any;
  conversationId: any;
  type: any;
  refetchUser?: any;
}

const Members = memo<Props>(
  ({ data, navigation, type, admin, conversationId, refetchUser }) => {
    const { i18n } = useTranslation();
    const { styles, colors } = useStyle();
    const dispatch = Store.useDispatch();
    const state = Store.useState();
    const [showModal, setShowModal] = useState(false);
    const [removeId, setRemoveId] = useState([]);
    const { userName } = userInfo();
    const lang = useLang();

    const isAdmin = admin
      ?.map((item: any) => {
        {
          return item?.user_name;
        }
      })
      .includes(userName);

    const toast = useToast();

    const { mutate } = usePutChatUpdateGroup({
      onSuccess: () => {
        setShowModal(false),
          setRemoveId([]),
          toast.show(i18n.t('removed'), {
            type: 'danger',
            placement: 'top',
            animationType: 'zoom-in',
          });
        refetchUser();
      },
    });

    const admins = admin.map((item: any) => {
      return item.user_name;
    });
    const renderItem = ({ item }: { item: any }) => (
      <View>
        <Spacing vertical={5} />
        <Button
          onClick={() => {
            setShowModal(true);
            setRemoveId(item?.user?.user_name);
            // Platform.isDesktop
            // ? handleChatInfo(ownerChat, item):
            // navigation.navigate(routesName.CHAT, {
            //   conversationId: item?.id,
            //   name: item?.user?.name_and_family,
            // });
          }}
        >
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Avatar
                openImage={false}
                statusShow={true}
                status={item?.user?.status}
                source={item?.user?.avatar}
                radius={80}
                size={70}
              />
              <Spacing horizontal={10} />
              <View>
                <Typography
                  text={item?.user?.name_and_family}
                  weight={'bold'}
                  color={colors.primaryColor}
                />
                <Spacing vertical={3} />
                <Typography
                  size={10}
                  text={item?.user?.status}
                  color={colors.secondryColor}
                />
              </View>
            </View>
            <View style={{ flexDirection: 'row' }}>
              {admins.includes(item?.user?.user_name) && (
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <Typography
                    text={i18n.t('admin')}
                    color={colors.secondryColor}
                  />
                </View>
              )}
              <Spacing horizontal={5} />
              <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                {isAdmin && type === 'group' && (
                  <AntDesignX name="delete" size={22} color={'#f9000077'} />
                )}
              </View>
            </View>
          </View>
        </Button>
        <Spacing vertical={5} />
        <Line />
      </View>
    );

    return (
      <>
        {isAdmin && type === 'group' && (
          <Dialog
            animationType={'fade'}
            handleModalClose={() => {
              setShowModal(false);
            }}
            modalVisible={showModal}
          >
            <View
              style={{
                width: 250,
                height: 100,
                flexDirection: 'row',
                direction: lang.isRtl ? 'rtl' : 'ltr',
              }}
            >
              <AntDesignX name="delete" size={15} color={'#f9000077'} />
              <Typography
                text={i18n.t('doYouWantToDeleteThisUser')}
                classes={styles.headerText}
              />
            </View>
            <View style={[styles.headerText, { flexDirection: 'row' }]}>
              <Button
                onClick={() => {
                  setShowModal(false);
                }}
              >
                {i18n.t('no')}
              </Button>
              <Spacing horizontal={20} />
              <Button
                onClick={() => {
                  mutate({
                    // @ts-ignore
                    requestBody: {
                      conversationId: conversationId,
                      ...(removeId?.length && { removes: [removeId] }),
                    },
                  });
                }}
              >
                {i18n.t('yes')}
              </Button>
            </View>
          </Dialog>
        )}
        <Typography text={i18n.t('members')} classes={styles.headerText} />
        <View style={styles.box}>
          <FlatList
            data={data}
            renderItem={renderItem}
            ListFooterComponent={() => (
              <>
                {isAdmin && type === 'group' && (
                  <>
                    <View>
                      <Spacing vertical={10} />
                      <Button
                        onClick={() => {
                          dispatch(showBottomSheetUpdate(true));
                        }}
                      >
                        <Typography
                          text={`${i18n.t('addMember')}...`}
                          weight={'bold'}
                          color={colors.color01}
                        />
                      </Button>
                    </View>
                    <Spacing vertical={10} />
                  </>
                )}
              </>
            )}
          />
        </View>
        <MyBottomSheet
          modalVisible={state.showBottomSheet}
          ModalClose={() => {
            dispatch(showBottomSheetUpdate(false));
          }}
          profile={true}
          groupMember={data}
          conversationId={conversationId}
          refetchUser={refetchUser}
        />
      </>
    );
  },
);

const useStyle = createUseStyles(({ colors }) => ({
  box: {
    padding: 20,
    margin: 10,
    borderRadius: 20,
    backgroundColor: colors.drawerHeaderBox,
  },
  headerText: {
    paddingLeft: 15,
    paddingRight: 15,
    color: colors.color01,
    fontWeight: 'bold',
  },
}));

export { Members };
